import axios from "axios";
import { AppContextInterface } from "../contexts/AppContext";
import { configAPIHeaders } from "./api";

import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';
import Config from "../config/Config";

const API_BUSINESS_URL = Config.BASE_URL_API_BUSINESS;
const notyf = new Notyf();

export const login = async (context: AppContextInterface, email: string, password: string) => {
	try {
		await axios.post(API_BUSINESS_URL + "/api/auth/signin", {
			email: email,
			password: password
		})
		.then(async response => {
			if (response.status === 200){
				if (response.data.token !== undefined){
					configAPIHeaders(context, response.data.token, response.data.user.id);

					context.setTokenValue(response.data.token);
					context.setUserEmailValue(response.data.user.email);
					context.setUserIDValue(response.data.user.id);

					localStorage.setItem("token", response.data.token);
					localStorage.setItem("email", response.data.user.email);
					localStorage.setItem("userID", response.data.user.id);

					// navigate("/orders");
				}
			} else if (response.status === 202){

			} else {
				notyf.error('Credenciais inválidas. Tente novamente.');
			}
			
		}).catch((error: any) => {
			notyf.error('Credenciais inválidas. Tente novamente.');
		});
	} catch (error){
		context.setLoadingLoginValue(false);
		context.setTokenValue(null);
		context.setUserEmailValue(null);
		context.setUserIDValue(null);
		notyf.error('Credenciais inválidas. Tente novamente.');
	}
}


const functionsAuth = {
	register (username: string, email: string, password: string){
		return axios.post(API_BUSINESS_URL + "/api/auth/signup", {
			username,
			email,
			password,
		});
	},
	Logout(){
		localStorage.removeItem("user");
		localStorage.clear();
		window.location.href = '/login';
	},
	getCurrentUser(){
		return localStorage.getItem("userID") !== undefined ? localStorage.getItem("userID") : "";
	}
};

export default functionsAuth;